import { render } from "./ExportRender.vue?vue&type=template&id=f79c84be&scoped=true&ts=true"
import script from "./ExportRender.vue?vue&type=script&lang=ts"
export * from "./ExportRender.vue?vue&type=script&lang=ts"

import "./ExportRender.vue?vue&type=style&index=0&id=f79c84be&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f79c84be"]])

export default __exports__